export default __webpack_public_path__ + "static/media/check-white.7dcc26db.svg";